import { Date } from "./Date";
import { User } from "./User";
import { Action, IJournal } from "../types/entities";
import { makeObservable, observable } from "mobx";

export class Journal implements IJournal {
  constructor(journal: IJournal) {
    makeObservable(this);

    Object.assign(this, journal);
  }

  @observable
  date: Date = new Date();

  @observable
  user: User = new User();

  @observable
  action: Action = Action.put;

  @observable
  productId: string = "";

  @observable
  fromTo: string = "";

  @observable
  value: number = 0;
}
